import React from "react";
import { CalendarDays } from "lucide-react";

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const DuePill = ({ due, done }) => {
  if (!due) return null;
  const day = String(due).slice(0, 10);
  const now = new Date();
  const today = ymd(now);
  const tomorrow = ymd(new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1));
  const cls = done ? "bg-[#F1F1F4] text-[#9FA1A4]" : day < today ? "bg-rose-50 text-rose-700 border border-rose-200"
    : day <= tomorrow ? "bg-amber-50 text-amber-800 border border-amber-200" : "bg-[#F6F6FD] text-[#595D62] border border-[#EEEFEF]";
  const label = new Date(`${day}T00:00:00`).toLocaleDateString("en-AU", { day: "numeric", month: "short" });
  const state = done ? "done" : day < today ? "overdue" : day <= tomorrow ? "soon" : "upcoming";
  return (
    <span data-testid="kanban-due-pill" data-state={state} title={`Due ${day}`} className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 font-mono-data text-[9px] ${cls}`}>
      <CalendarDays className="h-2.5 w-2.5" />{day === today && !done ? "Today" : label}
    </span>
  );
};
